import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-produk-add-angsuran',
  templateUrl: './produk-add-angsuran.component.html',
  styleUrls: ['./produk-add-angsuran.component.css']
})
export class ProdukAddAngsuranComponent implements OnInit {

  @Output() goBack = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<void>();

  // Settlement
  sum_pokok: boolean = false;
  sum_bunga: boolean = false;
  penalty_charge: string;
  admin_fee: number;
  formula_pelunasan_1: string;
  formula_pelunasan_2: string;
  formula_pelunasan_3: string;

  constructor() { }

  ngOnInit(): void {
  }

  back() {
    this.goBack.emit();
  }

  save() {
    this.onSave.emit();
  }
}
